<template>
  <div class="sub-page">
    <div class="sub-header" style="background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));">
      <van-nav-bar :title="$t('foorter.ti_record')" class="sub-nav">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>

    <div class="sub-body">
      <div class="card form-card">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
          <div v-else class="record-item van-hairline--bottom" v-for="(v, key) in list" :key="key">
            <div class="record-left">
              <div class="time">{{ v.addtime || v.update_time || v.create_time }}</div>
              <div class="tag">{{ v.type_name || $t('foorter.top9') }}</div>
            </div>
            <div class="profit-tag" :class="v.status == 2 ? 'minus' : 'plus'">
              {{ v.status == 2 ? '-' : '+' }}{{ v.num || v.profit || 0 }}
            </div>
          </div>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: []
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.getUserWithdrawList();
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserWithdrawList() {
      this.$http({
        method: 'get',
        url: 'user_get_money_list'
      }).then(res => {
        if (res && res.code === 200) {
          this.list = res.data || [];
        } else if (res) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserWithdrawList();
    }
  }
};
</script>

<style scoped>
.sub-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f3f3f5;
  padding-bottom: 60px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.sub-header {
  position: relative;
  width: 100%;
  height: 220px;
  background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));
  background-size: 100% auto;
  background-position: center bottom;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.sub-nav {
  background: transparent !important;
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__content {
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 34px !important;
  font-weight: 600 !important;
  line-height: 100px;
}

::v-deep .sub-nav .van-icon {
  color: #ffffff !important;
  font-size: 44px !important;
}

.sub-body {
  padding: 0 30px;
  margin-top: -60px;
  position: relative;
  z-index: 10;
}

.form-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 20px 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}

.record-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
}

.record-left .time {
  font-size: 28px;
  font-weight: 600;
  color: #333333;
}

.record-left .tag {
  display: inline-block;
  padding: 4px 16px;
  background-color: #9cce6d;
  color: #ffffff;
  font-size: 22px;
  border-radius: 8px;
  margin-top: 10px;
}

.profit-tag {
  padding: 6px 20px;
  color: #ffffff;
  font-size: 26px;
  border-radius: 12px;
  font-weight: 600;
}

.profit-tag.plus {
  background-color: #9cce6d;
}

.profit-tag.minus {
  background-color: #f26060;
}
</style>
